import React, { useState } from "react";
import { Box, IconButton, MenuItem, Popover, Typography, Tooltip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import { styled } from "@mui/material/styles";
import CustomIcon from "../../../../Components/CustomIcon";


const ActionMenuItem = styled(MenuItem)(({ theme }) => ({
    px: 12,
    py: 4,
    marginBottom: "6px",
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "12px",
    color: "#3D4B5A",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    lineHeight: "24px",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
        fontWeight: 500,
        color: "#6D72F6",
        backgroundColor: "#F4F5FF",
        "& .MuiSvgIcon-root": {
            color: "#6D72F6",
        },
    },
}));


const styles = {
    popoverPaper: {
        p: 1.5,
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 4px 4px 0px #C0C0C052',
    },
    header: {
        display: 'none',
        alignItems: 'center',
        paddingBottom: '8px',
        justifyContent: 'space-between'
    },
    headerText: {
        fontFamily: 'Roboto',
        fontWeight: 700,
        fontSize: '14px',
        lineHeight: '24px',
        color: '#3D4B5A',
        px: 1,
    },
    footer: {
        p: 0,
        display: 'flex',
        justifyContent: 'flex-end',
    },
};


const ChartActions = ({ actions }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'filter-popover' : undefined;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const handleMenuItemClick = (action) => {
        if (action.disabled) return;
        action.onClick && action.onClick();
        handleClose();
    }

    return (
        <>
            <IconButton onClick={handleClick} size="small">
                <MoreVertIcon />
            </IconButton>
            <Popover
                id={id}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                slotProps={{ paper: { sx: styles.popoverPaper } }}>

                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box sx={styles.header}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <SettingsRoundedIcon sx={{ fontSize: "16px", color: '#5E758D' }} />
                            <Typography sx={{ mx: 1 }} variant="fw700s12lh24c3D4B5A"> Row Settings </Typography>
                        </Box>
                    </Box>

                    <Box>
                        {actions.map((action, index) => {
                            const Item = (
                                <ActionMenuItem
                                    key={action.tooltip ? undefined : index}
                                    onClick={() => handleMenuItemClick(action)}
                                    disabled={action.disabled}
                                >
                                    {action.icon && <Box sx={{ mr: 1, pt: 0.5 }}><CustomIcon fontSize={'20px'} name={action.icon} /></Box>}
                                    {action.label}
                                </ActionMenuItem>
                            );

                            if (action.tooltip) {
                                return (
                                    <Tooltip
                                        key={index}
                                        title={action.tooltip}
                                        placement="bottom"
                                        slotProps={{
                                            tooltip: {
                                                sx: {
                                                    fontSize: '14px',
                                                    padding: '8px 12px'
                                                }
                                            }
                                        }}
                                    >
                                        <Box component="span" sx={{ width: '100%', display: 'block' }}>
                                            {Item}
                                        </Box>
                                    </Tooltip>
                                );
                            }

                            return Item;
                        })}
                    </Box>

                </Box>

            </Popover>
        </>
    );
};

export default ChartActions;
